<template>
    <modal :show="show">
        <div slot="modalHeader">
          <modal-header :closeModal="cancel">Choose a creative</modal-header>
        </div>
        <div v-if="field.type !=='assets'" class="form-group">
          <label for="format" class="control-label">Choose a Format</label>
          <select class="form-control" id="format" v-model="choices.format" v-on:change="checkSelection('format', $event)">
            <option value="" selected disabled>Please select a value</option>
            <option v-for="(value, key) in this.options.formats" :key="key" :value="key" >{{ value }}</option>
          </select>
        </div>
        <div v-if="stage >= stages.campaign && !isEmpty(options.campaigns)" class="form-group">
          <label for="campaign" class="control-label">Choose a campaign</label>
          <select class="form-control" id="campaign" v-model="choices.campaign" v-on:change="checkSelection('campaign', $event)">
            <option value="" selected disabled>Please select a value</option>
            <option v-for="(value, key) in this.options.campaigns" :key="key" :value="key">{{ value.name }}</option>
          </select>
        </div>
        <div v-if="stage >= stages.creative && !isEmpty(options.creatives)" class="form-group">
          <label for="creative" class="control-label">Choose a creative</label>
          <select class="form-control" id="creative" v-model="choices.creative" v-on:change="checkSelection('creative', $event)">
            <option value="" selected disabled>Please select a value</option>
            <option v-for="(value, key) in this.options.creatives" :key="key" :value="key">{{ value.name }}</option>
          </select>
        </div>
        <div slot="modalFooter">
          <modal-footer :closeModal="cancel" :confirm="confirm" cancelText="Cancel" :confirmText="this.confirmButtonText()" :confirmDisabled="!isReady"/>
        </div>
    </modal>
</template>

<script>
import Modal from '@/components/Modal/modal'
import ModalHeader from '@/components/Modal/modal-header'
import ModalFooter from '@/components/Modal/modal-footer'
import ButtonCta from '@/components/Button/button'
import {modalMixin} from '@/mixins/modalMixin'
import {creativeMixin} from '@/mixins/creativeMixin'
import {campaignMixin} from '@/mixins/campaignMixin'
import {notificationMixin} from '@/mixins/notificationMixin'

import { assoc, map } from 'ramda'

export default {
  name: 'modal_send_to_creative',
  mixins: [modalMixin, creativeMixin, notificationMixin, campaignMixin],
  components: {
    Modal,
    ModalHeader,
    ModalFooter,
    ButtonCta
  },
  props: {
    show: Boolean,
    confirmId: String,
    field: Object,
    currentCreativeId: {type: String, default: null}
  },
  data: () => ({
    stage: 1,
    stages: {
      format: 1,
      campaign: 2,
      creative: 3,
      ready: 4
    },
    choices: {
      format: '',
      campaign: '',
      campaignId: '',
      creativeId: '',
      creative: ''
    },
    options: {
      formats: {
        'png': 'png',
        'jpg': 'jpg',
        'gif': 'gif'
      },
      campaigns: Object,
      creatives: Object
    }
  }),
  mounted () {
    this.stage = this.stages.format
    // this.clientID = this.field.client.hash_id
    this.options.campaigns = map(item => assoc('campaignsActions', true, item), this.clientCampaigns)
  },
  watch: {
    show: function (val) {
      if (this.field.type === 'assets') {
        this.checkSelection('format', null)
      }
      if (val) {
        this.startLoading()
        this.getClientCampaigns(this.field.client.hash_id).then(() => {
          this.finishLoading()
          this.options.campaigns = this.clientCampaigns
        }, error => {
          this.finishLoading()
          this.addNotification('danger', error)
        })
      }
    }
  },
  computed: {
    isReady () {
      if (this.stage === this.stages.ready) {
        return true
      }
    }
  },
  methods: {
    isEmpty (obj) {
      if (Object.keys(obj).length === 0) {
        return true
      }
    },
    confirm () {
      // invoke an emit campaign
      const choices = {...this.choices}
      delete choices.campaign
      delete choices.creative
      if (this.field.type === 'assets') {
        this.$emit('assetsCopyToCreativeConfirm', choices)
      } else {
        this.$emit('sendToCreativeConfirm', choices)
      }
      this.cancel()
    },
    cancel () {
      this.choices.format = ''
      this.choices.campaign = ''
      this.choices.creative = ''
      this.stage = this.stages.format
      this.close()
    },
    checkSelection (stage, event) {
      switch (stage) {
        case 'format':
          // code block
          if (this.stage === this.stages.format) {
            this.stage = this.stages.campaign
          }
          break
        case 'campaign':
          // code block
          this.options.creatives = []
          if (this.stage === this.stages.campaign) {
            this.stage = this.stages.creative
          }
          this.choices.campaignId = this.options.campaigns[event.target.value].hash_id
          this.startLoading()
          this.getCreatives(this.choices.campaignId).then(() => {
            this.finishLoading()
            this.options.creatives = this.creatives.filter((creative) => creative.hash_id !== this.currentCreativeId)
          }, error => {
            this.finishLoading()
            this.addNotification('danger', error)
          })
          break
        case 'creative':
          // code block
          if (this.stage === this.stages.creative) {
            this.stage = this.stages.ready
          }
          this.choices.creativeId = this.options.creatives[event.target.value].hash_id
          break
        default:
          // do Nothing
          break
      }
    },
    confirmButtonText () {
      return `${this.field.copyAction === 'push' ? 'Send to' : 'Receive from'} Campaign`
    }
  }
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/Modal/creatives/modal-send-to-creative.vue